import { handle } from 'redux-pack';

import { Action } from "../../../types/actions";
import {
	BrandliveEvent,
	Color,
	CreateEventRequest,
	FontPack,
	RegistrationQuestion,
	Template,
	Session,
	PageModule,
	Requirement,
	CreateSession,
	GateTypes,
	RegistrationStepType,
	PrivacyPolicy,
	TermsConditions,
	RegistrationStep,
	EPreviewTypes,
	SelectedBrandliveEvent,
} from "../../../types/working-model";
import {
	ADD_NEW_COLOR_PACK,
	ADD_NEW_FONT_PACK,
	ADD_NEW_SESSION,
	ADD_REGISTRATION_QUESTION,
	ADD_REGISTRATION_REQUIREMENT,
	CREATE_NEW_EVENT,
	CREATE_NEW_SESSION,
	LOAD_COLOR_PACKS,
	LOAD_FONT_PACKS,
	LOAD_TEMPLATES,
	LOAD_WORKING_EVENT,
	REMOVE_REGISTRATION_QUESTION,
	SAVE_COLOR_PACK,
	SET_CUSTOM_CSS,
	SET_DESIGN_SHAPE,
	SET_DESIGN_STYLE,
	SET_EVENT_NAME,
	SET_REGISTRATION_FEATURE,
	SET_REGISTRATION_ON,
	SET_REGISTRATION_QUESTIONS,
	SET_REGISTRATION_TYPE,
	SET_SELECTED_COLOR,
	SET_SELECTED_FONT,
	SET_WORKING_EVENT,
	TOGGLE_REGISTRATION_QUESTION_REQUIRED,
	TOGGLE_HOMEPAGE_MODULE,
	UPDATE_HOMEPAGE_MODULE,
	UPDATE_HOMEPAGE_HEADER,
	UPDATE_HOMEPAGE_FOOTER,
	UPDATE_HOMEPAGE_MAIN_NAV,
	UPDATE_HOMEPAGE_PROFILE_NAV,
	UPDATE_POST_REGISTER_HOME_MODULES,
	SET_HOMEPAGE_MODULES,
	ADD_PAGE_MODULE,
	ADD_POST_REGISTER_HOME_PAGE_MODULE,
	CLEAR_WORKING_EVENT,
	SET_REGISTRATION_HEADER,
	SET_REGISTRATION_DESCRIPTION,
	SET_REGISTRATION_IMAGE,
	SET_REGISTRATION_LOGO,
	REMOVE_REGISTRATION_REQUIREMENT,
	UPDATE_REGISTRATION_REQUIREMENT,
	SET_BLOCKED_DOMAIN_EMAILS,
	DELETE_SESSION,
	REMOVE_SESSION,
	UPDATE_SESSION_INFO,
	REMOVE_IN_CREATION_PROGRESS_SESSION,
	EDIT_SESSION_AGENDA,
	UPDATE_EDITING_SESSION_BY_UID,
	UPDATE_WORKING_EVENT,
	DUPLICATE_SESSION,
	IS_SAVING,
	SET_AGENDA_IMAGE,
	DELETE_FONT_PACKS,
	DELETE_COLOR_PACKS,
	PUBLISH_EVENT,
	SET_REGISTRATION_SINGLE_SIGN_ON,
	CHOOSE_REGISTRATION_STEP,
	UPDATE_REGISTRATION_STEPS,
	UPDATE_REGISTRATION_SETTINGS,
	UPDATE_ALL_EVENT_SESSIONS_OVERLAY_CHAT,
	UPDATE_WORKING_EVENT_SESSION,
	UPDATE_ALL_EVENT_SESSIONS_LAYOUT_TABS,
	SET_DESIGN_COLORS,
	TOGGLE_POST_REGISTER_HOME_MODULE,
	ADD_REGISTRATION_STEP,
	ADD_TICKETING_SET,
	UPDATE_TICKETING_SET,
	REMOVE_TICKETING_SET,
	SET_SELECTED_EVENT,
	CLEAR_SELECTED_EVENT,
	SET_EDITOR_SIZE,
	TOGGLE_PREVIEW_MODE,
	ADD_WORKING_EVENT_HOMEPAGE,
	SET_EVENT_CUSTOM_CSS,
	UPDATE_REQUIRED_REGISTRATION_QUESTIONS,
	SET_SOCIAL_SHARING,
	GET_PUBLISHED_EVENT_URL,
	CLEAR_PUBLISHED_URL,
	UPDATE_PUBLISHED_EVENT_URL,
	UPDATE_EVENT_FAVICON,
	DELETE_EVENT_FAVICON,
	REMOVE_EVENT,
	ADD_NEW_SESSION_TO_STORE,
	ADD_HOMEPAGE_TO_WORKING_EVENT,
	TOGGLE_CUSTOMIZE_FORM_MODAL,
	loadWorkingEvent,
	isSavingEvent,
	BLUR_EDITOR,
} from '../../actions/admin/create-event';
import { GET_PRIVACY_POLICY, CREATE_PRIVACY_POLICY, UPDATE_PRIVACY_POLICY, CLEAR_PRIVACY_POLICY } from '../../actions/admin/privacy-policy';
import { GET_TERMS_CONDITIONS, CREATE_TERMS_CONDITIONS, UPDATE_TERMS_CONDITIONS, CLEAR_TERMS_CONDITIONS } from '../../actions/admin/terms-conditions';
import { GetDefaultMainNavItems, GetDefaultRegistrationSettings } from "../../utils/create-event";
import { SaveEvent } from "../../../connection/create-event";
import { Status } from '../../../types/event';

export interface Index {
	index: number;
}

export interface CreateEventState {
	newEventRequest: CreateEventRequest | null;
	templates: Template[] | null;
	workingEvent: BrandliveEvent | null;
	selectedEvent: SelectedBrandliveEvent | null;
	loadingEvent: boolean;
	eventNotFound: boolean;
	fontPacks: FontPack[];
	colorPacks: Color[];
	workingSession: Session | null;
	editingSessionAgenda: CreateSession | null;
	saving: boolean;
	registrationStep: RegistrationStepType;
	customizeFormModalOpen: boolean;
	termsConditions: TermsConditions | null;
	privacyPolicy: PrivacyPolicy | null;
	publishingEvent: boolean;
	errorPublishingEvent: boolean;
	editorSize: 'desktop' | 'tablet' | 'mobile';
	previewMode: EPreviewTypes | null,
	publishedUrl: string | null;
	deletingSession: boolean;
	blurEditor: boolean;
}

const initialState: CreateEventState = {
	newEventRequest: null,
	templates: null,
	workingEvent: null,
	selectedEvent: null,
	loadingEvent: false,
	eventNotFound: false,
	fontPacks: [],
	colorPacks: [],
	workingSession: null,
	editingSessionAgenda: null,
	saving: false,
	registrationStep: RegistrationStepType.general,
	customizeFormModalOpen: false,
	termsConditions: null,
	privacyPolicy: null,
	publishingEvent: false,
	errorPublishingEvent: false,
	editorSize: 'desktop',
	previewMode: null,
	publishedUrl: null,
	deletingSession: false,
	blurEditor: false,
};

let timeout: NodeJS.Timeout;

function getState(state: CreateEventState = initialState, action: Action): CreateEventState {
	switch (action.type) {
		case CREATE_NEW_EVENT: {
			return { ...state, newEventRequest: action.payload };
		}
		case LOAD_TEMPLATES: {
			return handle(state, action, {
				success: state => {
					return { ...state, templates: action.payload };
				}
			});
		}
		case CREATE_NEW_SESSION: {
			if (state.newEventRequest) {
				return {
					...state,
					newEventRequest: {
						...state.newEventRequest,
						sessions: [...state.newEventRequest.sessions, action.payload]
					}
				};
			} else return state;
		}
		case SET_EVENT_NAME: {
			if (state.newEventRequest) {
				return {
					...state,
					newEventRequest: { ...state.newEventRequest, name: action.payload }
				};
			} else {
				return state;
			}
		}
		case SET_WORKING_EVENT: {
			return {
				...state,
				workingEvent: action.payload
			};
		}
		case SET_SELECTED_EVENT: {
			return {
				...state,
				selectedEvent: action.payload
			};
		}
		case CLEAR_SELECTED_EVENT: {
			return {
				...state,
				selectedEvent: null
			};
		}
		case CLEAR_WORKING_EVENT: {
			return {
				...state,
				workingEvent: null
			};
		}
		case BLUR_EDITOR: {
			return {
				...state,
				blurEditor: true,
			};
		}
		case LOAD_WORKING_EVENT: {
			return handle(state, action, {
				start: (state) => ({
					...state,
					loadingEvent: true,
					eventNotFound: false,
				}),
				success: state => {
					if (action.payload.error) {
						return ({ ...state, workingEvent: null, eventNotFound: true });
					}
					return ({ ...state, workingEvent: action.payload, eventNotFound: false });
				},
				failure: state => {
					return ({ ...state, workingEvent: null, eventNotFound: true });
				},
				finish: state => {
					return {
						...state,
						loadingEvent: false,
						blurEditor: false,
					};
				}
			});
		}
		case ADD_NEW_SESSION_TO_STORE: {
			if (state.workingEvent) {
				const { timestamp, end_timestamp } = action.payload;
				const newSession = {
					...action.payload,
					timestamp: new Date(timestamp).valueOf(),
					end_timestamp: new Date(end_timestamp).valueOf()
				};
				const selectedEvent = state?.selectedEvent ? { ...state.selectedEvent } : null;
				if (selectedEvent && selectedEvent?.uuid === action?.payload?.uuid) {
					selectedEvent.sessions = [newSession, ...(selectedEvent?.sessions || [])];
				}
				return ({
					...state,
					workingEvent: {
						...state.workingEvent,
						sessions: [newSession, ...state.workingEvent?.sessions],
					},
					selectedEvent,
				});
			} else {
				return state;
			}
		}
		case ADD_HOMEPAGE_TO_WORKING_EVENT: {
			if (!state?.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					homepage: action.payload,
				},
			};
		}
		case ADD_NEW_SESSION: {
			return handle(state, action, {
				success: state => {
					if (action.payload.error) {
						return state;
					} else if (state.workingEvent) {
						const { timestamp, end_timestamp } = action.payload;
						const newSession = {
							...action.payload,
							timestamp: new Date(timestamp).valueOf(),
							end_timestamp: new Date(end_timestamp).valueOf()
						};
						const selectedEvent = state?.selectedEvent ? { ...state.selectedEvent } : null;
						if (selectedEvent && selectedEvent?.uuid === action?.payload?.uuid) {
							selectedEvent.sessions = [newSession, ...(selectedEvent?.sessions || [])];
						}
						return ({
							...state,
							workingEvent: {
								...state.workingEvent,
								sessions: [newSession, ...state.workingEvent?.sessions],
							},
							selectedEvent,
						});
					} else {
						return state;
					}
				},
			});
		}
		case DUPLICATE_SESSION: {
			return handle(state, action, {
				success: state => {
					if (action.payload.error) {
						return state;
					} else if (state.workingEvent) {
						const { timestamp, end_timestamp } = action.payload;
						const newSession = {
							...action.payload,
							timestamp: new Date(timestamp).valueOf(),
							end_timestamp: new Date(end_timestamp).valueOf()
						};
						return ({ ...state, workingEvent: { ...state.workingEvent, sessions: [newSession, ...state.workingEvent?.sessions,] } });
					} else {
						return state;
					}
				},
			});
		}
		case DELETE_SESSION: {
			return handle(state, action, {
				start: state => ({ ...state, deletingSession: true }),
				finish: state => ({ ...state, deletingSession: false }),
				success: state => {
					if (action.payload.error) {
						return state;
					}
					if (state.workingEvent) {
						const { sessions } = state.workingEvent;
						const updatedSessions = sessions.filter(session => session.session !== action.payload.session);
						return {
							...state,
							workingEvent: { ...state.workingEvent, sessions: updatedSessions },
							selectedEvent: state?.selectedEvent ? {
								...state.selectedEvent,
								sessions: updatedSessions,
								_sessions: updatedSessions,
							} : null,
						};
					}
					if (state.selectedEvent) {
						const { sessions } = state?.selectedEvent;
						const updatedSessions = sessions.filter(session => session.session !== action.payload.session);
						return {
							...state,
							selectedEvent: {
								...state.selectedEvent,
								sessions: updatedSessions,
								_sessions: updatedSessions,
							},
						};
					}
					return state;
				},
			});
		}
		case REMOVE_SESSION: {
			let copy = { ...state };
			if (state.workingEvent) {
				copy = {
					...copy,
					workingEvent: {
						...state.workingEvent,
						sessions: state.workingEvent.sessions.filter(session => session.session !== action.payload.session),
					},
				};
			}
			if (state?.selectedEvent?._sessions || state?.selectedEvent?.sessions) {
				copy = {
					...copy,
					selectedEvent: {
						...state.selectedEvent,
						sessions: state?.selectedEvent?.sessions?.filter(s => s.session !== action.payload.session) ?? null,
						_sessions: state?.selectedEvent?._sessions?.filter(s => s.session !== action.payload.session) ?? null,
					}
				};
			}
			return copy;
		}
		case REMOVE_EVENT: {
			return {
				...state,
				workingEvent: state?.workingEvent?.uuid === action.payload ? null : state.workingEvent,
				selectedEvent: null,
			};
		}
		case UPDATE_SESSION_INFO: {
			return handle(state, action, {
				success: state => {
					if (action.payload.error) {
						return state;
					} else if (state.workingEvent) {
						const { sessions } = state.workingEvent;
						const updatedSessions = [...sessions];
						const updateIndex = updatedSessions.findIndex((session) => session.uuid === action.payload.uuid);

						if (updateIndex >= 0) {
							updatedSessions.splice(updateIndex, 1, action.payload);
						}

						return ({ ...state, workingEvent: { ...state.workingEvent, sessions: updatedSessions } });
					} else {
						return state;
					}
				}
			});
		}
		case SET_REGISTRATION_ON: {
			return {
				...state,
				workingEvent: {
					...state.workingEvent as BrandliveEvent,
					registration_on: action.payload as boolean,
				}
			};
		}
		case SET_REGISTRATION_TYPE: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent as BrandliveEvent,
						registration_settings: {
							...state.workingEvent?.registration_settings,
							type: action.payload,
						},
					},
				});
			} else {
				return state;
			}
		}
		case UPDATE_REGISTRATION_SETTINGS: {
			if (!state.workingEvent) return state;
			return handle(state, action, {
				success: (state) => {
					return {
						...state,
						workingEvent: {
							...state.workingEvent!,
							registration_settings: action.payload
						}
					};
				}
			});
		}
		case SET_REGISTRATION_FEATURE: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent as BrandliveEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							[action.payload.feature]: action.payload.on
						}
					}
				});
			} else {
				return state;
			}
		}
		case SET_REGISTRATION_SINGLE_SIGN_ON: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							singleSignOns: action.payload
						}
					}
				});
			} else {
				return state;
			}
		}
		case SET_BLOCKED_DOMAIN_EMAILS: {
			if (state.workingEvent?.registration_settings) {
				return ({
					...state,
					workingEvent: {
						...state.workingEvent as BrandliveEvent,
						registration_settings: {
							...state.workingEvent.registration_settings,
							blockedDomainEmails: action.payload
						}
					}
				});
			} else {
				return state;
			}
		}
		case ADD_REGISTRATION_REQUIREMENT: {
			if (!state.workingEvent) return state;
			const workingEvent = { ...state.workingEvent };
			const { type, newRequirement }: {
				type: GateTypes;
				newRequirement: Requirement
			} = action.payload;

			const requirementsCopy = { ...workingEvent.registration_settings?.requirements };

			if (type === GateTypes.passcode_list) {
				if (requirementsCopy[GateTypes.passcode_list]?.length) {
					requirementsCopy[GateTypes.passcode_list]?.push(newRequirement);
				} else {
					requirementsCopy[GateTypes.passcode_list] = [newRequirement];
				}
			} else {
				requirementsCopy[type] = newRequirement;
			}

			if (workingEvent.registration_settings) {
				workingEvent.registration_settings = {
					...workingEvent.registration_settings,
					requirements: requirementsCopy
				};
			} else {
				workingEvent.registration_on = true;
				workingEvent.registration_settings = {
					...GetDefaultRegistrationSettings(),
					requirements: requirementsCopy
				};
			}

			return ({ ...state, workingEvent: workingEvent });
		}

		case REMOVE_REGISTRATION_REQUIREMENT: {
			if (!state.workingEvent) return state;
			let workingEvent = { ...state.workingEvent };
			const { type, passcodeListIndex }: {
				type: GateTypes;
				passcodeListIndex: number
			} = action.payload;

			let requiredQnsStepsCopy = workingEvent?.required_registration_questions ? [...workingEvent.required_registration_questions] : null;
			const requirementsCopy = { ...workingEvent.registration_settings?.requirements };

			delete requirementsCopy[type];

			if (type === GateTypes.passcode_list) {
				requirementsCopy[GateTypes.passcode_list]?.splice(passcodeListIndex, 1);
			}

			// if shared_passcode, then we need to remove the passcode question from the questions list
			// otherwise it shows up during the signin flow
			if (type === GateTypes.shared_passcode) {
				const generalStep = workingEvent.registration_steps?.find?.(step => step.type === RegistrationStepType.general);
				if (generalStep) {
					// remove the question from questions
					const results = generalStep?.questions?.reduce?.(
						(accum: any, curr: any): any => {
							const updated = { ...accum };
							// TODO: we need a better way to access this. If the "name" ever changes it will stop working
							// we need to add the gate type to the question so we can identify it.
							if (curr?.name === 'Passcode') {
								updated.passcode = curr;
							} else {
								updated.rest.push(curr);
							}
							return updated;
						},
						{ passcode: null, rest: [] }
					) as { passcode: RegistrationQuestion | null, rest: RegistrationQuestion[] };
					// and extract the regustrtion_question number from it
					const passcodeQuestion = results?.passcode?.registration_question as (number | null);
					if (passcodeQuestion && requiredQnsStepsCopy) {
						workingEvent = {
							...workingEvent,
							registration_steps: workingEvent?.registration_steps?.map?.(step => {
								if (step.type !== RegistrationStepType.general) return step;
								return {
									...step,
									questions: step.questions?.filter(qn => qn.registration_question !== passcodeQuestion),
								};
							}),
						};
						// and remove that number from required_registration_questions
						requiredQnsStepsCopy = requiredQnsStepsCopy.filter(step => step !== passcodeQuestion);
					}
				}
			}

			if (workingEvent.registration_settings) {
				workingEvent.registration_settings = {
					...workingEvent.registration_settings,
					requirements: requirementsCopy,
				};
			}

			return {
				...state,
				workingEvent: {
					...workingEvent,
					required_registration_questions: requiredQnsStepsCopy,
				},
			};
		}

		case UPDATE_REGISTRATION_REQUIREMENT: {
			if (!state.workingEvent) return state;
			const workingEvent = { ...state.workingEvent };
			const { type, passcodeListIndex, updatedRequirement }: {
				type: GateTypes;
				passcodeListIndex: number;
				updatedRequirement: Requirement
			} = action.payload;

			const requirementsCopy = { ...workingEvent.registration_settings?.requirements };

			if (type === GateTypes.passcode_list) {
				requirementsCopy[type] = requirementsCopy[type]?.map((passcodeList, index) => {
					if (index === passcodeListIndex) return updatedRequirement;
					else return passcodeList;
				});
			} else {
				requirementsCopy[type] = updatedRequirement;
			}

			if (workingEvent.registration_settings) {
				workingEvent.registration_settings = {
					...workingEvent.registration_settings,
					requirements: requirementsCopy
				};
			}

			return { ...state, workingEvent: workingEvent };
		}
		case CHOOSE_REGISTRATION_STEP: {
			return { ...state, registrationStep: action.payload };
		}
		case TOGGLE_CUSTOMIZE_FORM_MODAL: {
			return { ...state, customizeFormModalOpen: action.payload };
		}
		case UPDATE_REGISTRATION_STEPS: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_steps: action.payload,
				}
			};
		}
		case UPDATE_REQUIRED_REGISTRATION_QUESTIONS: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					required_registration_questions: action.payload
				}
			};
		}

		//not currently in use, but we are planning at some point to add the ability to add more steps
		case ADD_REGISTRATION_STEP: {
			if (!state.workingEvent) return state;

			if (!state.workingEvent.registration_steps) {
				console.error("Tried adding a registration step to an empty set.");
				return state;
			}

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_steps: [
						...state.workingEvent.registration_steps,
						action.payload
					]
				}
			};
		}

		case ADD_TICKETING_SET: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			if (!_workingEvent.registration_steps) {
				console.error("Tried adding a registration step to an empty set.");
				return state;
			}

			const exists = _workingEvent.registration_steps.find(step => step.type == RegistrationStepType.ticketing) !== undefined;

			if (!exists) {
				const step: RegistrationStep = {
					isOn: true,
					type: RegistrationStepType.ticketing,
				};

				_workingEvent.registration_steps.splice(1, 0, step);
			}

			_workingEvent.registration_steps = _workingEvent.registration_steps.map(step => {
				const stepCopy = { ...step };
				if (stepCopy.type === RegistrationStepType.ticketing) {
					stepCopy.ticketing = [...stepCopy.ticketing ?? [], action.payload];
					stepCopy.isOn = true;
				}

				return stepCopy;
			});

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case UPDATE_TICKETING_SET: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			if (!_workingEvent.registration_steps) {
				console.error("Tried adding a registration step to an empty set.");
				return state;
			}

			const { set, index } = action.payload;

			_workingEvent.registration_steps = _workingEvent.registration_steps.map(step => {
				if (step.type === RegistrationStepType.ticketing) {
					step.ticketing = step.ticketing!.map((ticketingSet, _index) => {
						if (_index === index) {
							return set;
						} else {
							return ticketingSet;
						}
					});
				}

				return step;
			});

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case REMOVE_TICKETING_SET: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			if (!_workingEvent.registration_steps) {
				console.error("Tried adding a registration step to an empty set.");
				return state;
			}
			_workingEvent.registration_steps = _workingEvent.registration_steps.map(step => {
				const stepCopy = { ...step };
				if (stepCopy.type === RegistrationStepType.ticketing) {
					stepCopy.ticketing = stepCopy.ticketing!.filter((tick, index) => {
						return index !== action.payload;
					});
					if (!stepCopy?.ticketing?.length) {
						stepCopy.isOn = false;
					}
				}
				return stepCopy;
			});

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case ADD_REGISTRATION_QUESTION: {
			if (!state.workingEvent) return state;

			return ({
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_questions: [
						...state.workingEvent.registration_questions,
						action.payload
					]
				}
			});
		}
		case REMOVE_REGISTRATION_QUESTION: {
			if (!state.workingEvent) return state;

			const newQuestions = state.workingEvent.registration_questions.filter((question: RegistrationQuestion) => {
				return question.registration_question !== action.payload.registration_question;
			});

			return ({
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_questions: newQuestions
				}
			});
		}
		case TOGGLE_REGISTRATION_QUESTION_REQUIRED: {
			if (!state.workingEvent) return state;

			if (action.payload.required) {
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						required_registration_questions: [
							...state.workingEvent.required_registration_questions ?? [],
							action.payload.question
						]
					}
				};
			} else {
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						required_registration_questions: state.workingEvent.required_registration_questions?.filter((_question: number) => {
							return _question !== action.payload.question;
						}) ?? []
					}
				};
			}
		}
		case SET_REGISTRATION_QUESTIONS: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					registration_questions: action.payload.questions,
					required_registration_questions: action.payload.required_questions
				}
			};
		}
		case LOAD_FONT_PACKS: {
			return handle(state, action, {
				success: state => ({ ...state, fontPacks: action.payload })
			});
		}
		case SET_SELECTED_FONT: {
			if (!state.workingEvent) return state;

			const workingEvent = { ...state.workingEvent };
			workingEvent.settings.design.font = action.payload;

			return {
				...state,
				workingEvent
			};
		}
		case ADD_NEW_FONT_PACK: {
			if (!state.workingEvent) return state;

			return {
				...state,
				fontPacks: [action.payload, ...state.fontPacks]
			};
		}
		case DELETE_FONT_PACKS: {
			return handle(state, action, {
				success: state => {
					const {
						// cannotDelete, //cannot delete messaging handled in Content Reducer
						deletedFonts
					}: {
						// cannotDelete: number[];
						deletedFonts: number[];
					} = action.payload;

					let updatedFonts = [...state.fontPacks];

					if (deletedFonts?.length === 1) {
						const fontIndex = updatedFonts.findIndex(font => font.font_pack === deletedFonts[0]);
						if (fontIndex >= 0) updatedFonts.splice(fontIndex, 1);
					} else {
						updatedFonts = updatedFonts.filter(font => !deletedFonts.includes(font.font_pack));
					}

					return {
						...state,
						fontPacks: updatedFonts
					};
				}
			});
		}
		case LOAD_COLOR_PACKS: {
			return handle(state, action, {
				success: state => {
					return ({ ...state, colorPacks: action.payload });
				}
			});
		}
		case SET_SELECTED_COLOR: {
			if (!state.workingEvent) return state;

			const workingEvent = { ...state.workingEvent };
			workingEvent.settings.design.colors = action.payload;

			return {
				...state,
				workingEvent
			};
		}
		case ADD_NEW_COLOR_PACK: {
			return {
				...state,
				colorPacks: [action.payload, ...state.colorPacks]
			};
		}
		case SAVE_COLOR_PACK: {
			return {
				...state,
				colorPacks: state.colorPacks.map((color: Color) => {
					if (color.color_pack === action.payload.color_pack) {
						return action.payload;
					} else return color;
				})
			};
		}
		case DELETE_COLOR_PACKS: {
			return handle(state, action, {
				success: state => {
					const {
						// cannotDelete, //cannot delete messaging handled in Content Reducer
						deletedColors
					}: {
						// cannotDelete: number[];
						deletedColors: number[];
					} = action.payload;

					let updatedColors = [...state.colorPacks];

					if (deletedColors?.length === 1) {
						const colorIndex = updatedColors.findIndex(color => color.color_pack === deletedColors[0]);
						if (colorIndex >= 0) updatedColors.splice(colorIndex, 1);
					} else {
						updatedColors = updatedColors.filter(color => !deletedColors.includes(color.color_pack));
					}

					return {
						...state,
						colorPacks: updatedColors
					};
				}
			});
		}
		case SET_DESIGN_STYLE: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.settings.design.style.style = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}
		case SET_DESIGN_SHAPE: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.settings.design.style.shape = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}
		case SET_DESIGN_COLORS: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.settings.design.colors = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}
		case SET_CUSTOM_CSS: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.settings.customCSS = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case TOGGLE_HOMEPAGE_MODULE: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.homepage!.modules = _workingEvent.homepage!.modules.map((module: PageModule) => {
				if (module.id === action.payload.id) {
					module.is_on = !module.is_on;
				}

				return module;
			});

			return { ...state, workingEvent: _workingEvent };
		}

		case TOGGLE_POST_REGISTER_HOME_MODULE: {
			if (state.workingEvent?.homepage?.post_register_home_modules) {
				return {
					...state,
					workingEvent: {
						...state.workingEvent,
						homepage: {
							...state.workingEvent?.homepage,
							post_register_home_modules: state.workingEvent?.homepage?.post_register_home_modules.map(module => {
								if (module.module_id === action.payload.moduleId) {
									return {
										...module,
										is_on: action.payload.is_on,
									};
								}
								return module;
							}),
						}
					}
				};
			}
			return state;
		}

		case UPDATE_HOMEPAGE_MODULE: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;
			const _workingEvent = { ...state.workingEvent };
			_workingEvent.homepage!.modules = _workingEvent.homepage!.modules.map((module: PageModule) => {
				if (module.id === action.payload.id) return action.payload;
				return module;
			});
			_workingEvent.status = 2;
			return { ...state, workingEvent: _workingEvent };
		}

		case SET_HOMEPAGE_MODULES: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;
			const _workingEvent = { ...state.workingEvent };

			_workingEvent.homepage!.modules = action.payload;
			return { ...state, workingEvent: _workingEvent };
		}

		case UPDATE_HOMEPAGE_HEADER: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.homepage!.header = action.payload;

			return { ...state, workingEvent: _workingEvent };
		}

		case UPDATE_HOMEPAGE_FOOTER: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.homepage!.footer = action.payload;

			return { ...state, workingEvent: _workingEvent };
		}

		case UPDATE_HOMEPAGE_MAIN_NAV: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			const _workingEvent = { ...state.workingEvent };
			if (_workingEvent?.homepage) {
				return {
					...state,
					workingEvent: {
						..._workingEvent,
						homepage: {
							..._workingEvent.homepage,
							event_main_nav_items: action.payload,
						},
					},
				};
			}
			return state;
		}

		case UPDATE_HOMEPAGE_PROFILE_NAV: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			const _workingEvent = { ...state.workingEvent };
			if (_workingEvent?.homepage) {
				return {
					...state,
					workingEvent: {
						..._workingEvent,
						homepage: {
							..._workingEvent.homepage,
							event_profile_nav_items: action.payload,
						},
					},
				};
			}
			return state;
		}

		case UPDATE_POST_REGISTER_HOME_MODULES: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					homepage: {
						...state.workingEvent.homepage,
						post_register_home_modules: action.payload,
					}
				}
			};
		}

		case ADD_PAGE_MODULE: {
			if (!state.workingEvent || !state.workingEvent.homepage) return state;
			const _workingEvent = { ...state.workingEvent };
			_workingEvent.homepage!.modules = [..._workingEvent.homepage!.modules, action.payload];
			return { ...state, workingEvent: _workingEvent };
		}

		case ADD_POST_REGISTER_HOME_PAGE_MODULE: {
			return handle(state, action, {
				success: prevState => {
					if (!prevState.workingEvent || !prevState.workingEvent?.homepage?.post_register_home_modules) return prevState;
					return {
						...prevState,
						workingEvent: {
							...prevState.workingEvent,
							homepage: {
								...prevState.workingEvent.homepage,
								post_register_home_modules: [
									...prevState.workingEvent.homepage.post_register_home_modules,
									{ module_id: action.payload.id, is_on: false },
								]
							}
						}
					};
				},
				failure: prevState => {
					console.log('FAILURE');
					return prevState;
				},
			});
		}

		case SET_REGISTRATION_HEADER: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.registration_settings!.title = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}


		case SET_REGISTRATION_DESCRIPTION: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.registration_settings!.description = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case SET_REGISTRATION_IMAGE: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.registration_settings!.image = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case SET_REGISTRATION_LOGO: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };
			_workingEvent.registration_settings!.logo = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case SET_EVENT_CUSTOM_CSS: {
			if (!state.workingEvent) return state;

			const _workingEvent = { ...state.workingEvent };

			_workingEvent.custom_css = action.payload;

			return {
				...state,
				workingEvent: _workingEvent
			};
		}

		case REMOVE_IN_CREATION_PROGRESS_SESSION: {
			if (!state?.newEventRequest?.sessions) return state;
			return {
				...state,
				newEventRequest: {
					...state.newEventRequest,
					sessions: state.newEventRequest.sessions.filter((session) => session.uid !== action.payload),
				},
			};
		}

		case EDIT_SESSION_AGENDA: {
			if (!action.payload && action.payload !== 0) {
				return {
					...state,
					editingSessionAgenda: null,
				};
			}
			const matchedSession: CreateSession | null = state?.newEventRequest?.sessions?.find((value) => value.uid === action.payload) || null;
			if (matchedSession) {
				return {
					...state,
					editingSessionAgenda: matchedSession,
				};
			}
			return state;
		}

		case UPDATE_EDITING_SESSION_BY_UID: {
			if (!action.payload) return state;
			return {
				...state,
				newEventRequest: state?.newEventRequest ? {
					...state.newEventRequest,
					sessions: state?.newEventRequest?.sessions?.map((session) => {
						if (action?.payload?.uid === session?.uid) return action.payload;
						return session;
					}) || [],
				} : null,
				editingSessionAgenda: null,
			};
		}

		case UPDATE_WORKING_EVENT: {
			return ({
				...state,
				workingEvent: action.payload,
			});
		}
		case ADD_WORKING_EVENT_HOMEPAGE: {
			const isSingleSession = state.workingEvent?.sessions?.length === 1;
			return handle(state, action, {
				success: (state) => {
					if (!state.workingEvent) return state;
					const _workingEvent = { ...state.workingEvent };
					return {
						...state,
						workingEvent: {
							..._workingEvent,
							homepage: {
								...action.payload,
								event_main_nav_items: GetDefaultMainNavItems(isSingleSession)
							}
						}
					};
				},
				failure: state => state,
			});
		}

		case IS_SAVING: {
			return {
				...state,
				saving: action.payload,
			};
		}

		case SET_AGENDA_IMAGE: {
			if (!state.workingEvent) return state;
			const { url, session } = action.payload;

			// find the matching session and set the url to the image field
			const _workingEvent = { ...state.workingEvent };
			return {
				...state,
				workingEvent: {
					..._workingEvent,
					sessions: _workingEvent.sessions.map((_workingSession: Session) => {
						if (_workingSession.session !== session) return _workingSession;
						return {
							..._workingSession,
							image: url,
						};
					}),
				},
			};
		}

		case PUBLISH_EVENT: {
			return handle(state, action, {
				success: (state) => {
					if (!state.workingEvent) return state;
					const _workingEvent = { ...state.workingEvent };
					return {
						...state,
						errorPublishingEvent: false,
						workingEvent: {
							..._workingEvent,
							status: 1
						}
					};
				},
				start: (state) => ({ ...state, publishingEvent: true }),
				finish: (state) => ({ ...state, publishingEvent: false }),
				failure: (state) => ({ ...state, errorPublishingEvent: true })
			});
		}

		case UPDATE_ALL_EVENT_SESSIONS_OVERLAY_CHAT: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					sessions: state.workingEvent.sessions.map(session => ({
						...session,
						layout: {
							...session.layout,
							overlayChat: !!action.payload,
						}
					}))
				}
			};
		}

		case UPDATE_ALL_EVENT_SESSIONS_LAYOUT_TABS: {
			if (!state.workingEvent) return state;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					sessions: state.workingEvent.sessions.map(session => ({
						...session,
						layout: {
							...session.layout,
							tabs: action.payload,
						}
					}))
				}
			};
		}

		case UPDATE_WORKING_EVENT_SESSION: {
			if (!state.workingEvent) return state;
			const updatedSession: Session = action.payload;
			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					sessions: state.workingEvent.sessions.map(session => {
						if (session.uuid === updatedSession.uuid) return updatedSession;
						return session;
					})
				}
			};
		}

		case GET_PRIVACY_POLICY: {
			return handle(state, action, {
				success: state => {
					// only update privacyPolicy if it still matches the current workingEvent
					if (state.workingEvent?.privacy_policy === action.payload?.privacy_policy) {
						return { ...state, privacyPolicy: action.payload };
					} else {
						return state;
					}
				}
			});
		}

		case CREATE_PRIVACY_POLICY: {
			return handle(state, action, {
				success: state => {
					const { eventID, newPolicy } = action.payload;

					if (state.workingEvent && state.workingEvent.uuid === eventID) {
						return {
							...state,
							workingEvent: {
								...state.workingEvent,
								privacy_policy: newPolicy.privacy_policy,
							},
							privacyPolicy: newPolicy,
						};
					} else {
						return state;
					}
				}
			});
		}

		case UPDATE_PRIVACY_POLICY: {
			return handle(state, action, {
				success: state => {
					// only update privacyPolicy if it still matches the current workingEvent
					if (state.workingEvent?.privacy_policy === action.payload?.privacy_policy) {
						return { ...state, privacyPolicy: action.payload };
					} else {
						return state;
					}
				}
			});
		}

		case CLEAR_PRIVACY_POLICY: {
			return {
				...state,
				privacyPolicy: null,
			};
		}

		case GET_TERMS_CONDITIONS: {
			return handle(state, action, {
				success: state => {
					// only update termsConditions if it still matches the current workingEvent
					if (state.workingEvent?.terms_id === action.payload?.terms_id) {
						return { ...state, termsConditions: action.payload };
					} else {
						return state;
					}
				}
			});
		}

		case CREATE_TERMS_CONDITIONS: {
			return handle(state, action, {
				success: state => {
					const { eventID, newTerms } = action.payload;

					if (state.workingEvent && state.workingEvent.uuid === eventID) {
						return {
							...state,
							workingEvent: {
								...state.workingEvent,
								terms_id: newTerms.terms_id,
							},
							termsConditions: newTerms,
						};
					} else {
						return state;
					}
				}
			});
		}

		case UPDATE_TERMS_CONDITIONS: {
			return handle(state, action, {
				success: state => {
					// only update termsConditions if it still matches the current workingEvent
					if (state.workingEvent?.terms_id === action.payload?.terms_id) {
						return { ...state, termsConditions: action.payload };
					} else {
						return state;
					}
				}
			});
		}

		case CLEAR_TERMS_CONDITIONS: {
			return {
				...state,
				termsConditions: null,
			};
		}

		case SET_EDITOR_SIZE: {
			return {
				...state,
				editorSize: action.payload
			};
		}

		case TOGGLE_PREVIEW_MODE: {
			return {
				...state,
				previewMode: action.payload
			};
		}

		case SET_SOCIAL_SHARING: {
			if (!state.workingEvent) return state;

			return {
				...state,
				workingEvent: {
					...state.workingEvent,
					social_sharing: action.payload
				}
			};
		}

		case GET_PUBLISHED_EVENT_URL: {
			return handle(state, action, {
				success: state => {
					if (action.payload?.status === Status.Published) {
						return {
							...state,
							publishedUrl: action.payload.url
						};
					} else {
						return {
							...state,
							publishedUrl: ''
						};
					}
				}
			});
		}

		case UPDATE_PUBLISHED_EVENT_URL: {
			return {
				...state,
				publishedUrl: action.payload
			};
		}

		case CLEAR_PUBLISHED_URL: {
			return {
				...state,
				publishedUrl: null
			};
		}

		case UPDATE_EVENT_FAVICON: {
			return handle(state, action, {
				success: state => {
					return {
						...state,
						workingEvent: state?.workingEvent ? {
							...state.workingEvent,
							favicon: action.payload.favicon,
						} : null,
						selectedEvent: state?.selectedEvent ? {
							...state.selectedEvent,
							favicon: action.payload.favicon,
						} : null,
					};
				},
			});
		}

		case DELETE_EVENT_FAVICON: {
			return handle(state, action, {
				success: state => {
					return {
						...state,
						workingEvent: state?.workingEvent ? {
							...state.workingEvent,
							favicon: null,
						} : null,
						selectedEvent: state?.selectedEvent ? {
							...state.selectedEvent,
							favicon: null,
						} : null,
					};
				},
			});
		}

		default: return state;
	}
}

const SAVING_ACTION = [
	ADD_REGISTRATION_REQUIREMENT,
	ADD_NEW_SESSION,
	UPDATE_SESSION_INFO,
	SET_REGISTRATION_HEADER,
	SET_REGISTRATION_DESCRIPTION,
	SET_REGISTRATION_IMAGE,
	SET_REGISTRATION_LOGO,
	SET_REGISTRATION_ON,
	SET_REGISTRATION_TYPE,
	SET_REGISTRATION_FEATURE,
	SET_REGISTRATION_SINGLE_SIGN_ON,
	SET_REGISTRATION_QUESTIONS,
	SET_SELECTED_FONT,
	SET_SELECTED_COLOR,
	SET_DESIGN_SHAPE,
	SET_DESIGN_STYLE,
	SET_CUSTOM_CSS,
	UPDATE_HOMEPAGE_MODULE,
	UPDATE_HOMEPAGE_FOOTER,
	UPDATE_HOMEPAGE_HEADER,
	UPDATE_HOMEPAGE_MAIN_NAV,
	UPDATE_HOMEPAGE_PROFILE_NAV,
	SET_HOMEPAGE_MODULES,
	ADD_PAGE_MODULE,
	TOGGLE_POST_REGISTER_HOME_MODULE,
	SET_BLOCKED_DOMAIN_EMAILS,
	REMOVE_REGISTRATION_REQUIREMENT,
	UPDATE_REGISTRATION_REQUIREMENT,
	UPDATE_TICKETING_SET,
	ADD_TICKETING_SET,
	REMOVE_TICKETING_SET,
	SET_EVENT_CUSTOM_CSS,
	UPDATE_REQUIRED_REGISTRATION_QUESTIONS,
	SET_SOCIAL_SHARING
];
const REFETCHING_ACTION = [
	ADD_NEW_SESSION,
	UPDATE_SESSION_INFO,
];

export default function CreateEventReducer(state: CreateEventState = initialState, action: Action): CreateEventState {
	const newState = getState(state, action);


	if (SAVING_ACTION.includes(action.type)) {
		// cleartimeout must go inside the if statement, otherwise it can be accidentally cancelled
		clearTimeout(timeout);
		timeout = setTimeout(async () => {
			// eslint-disable-next-line @typescript-eslint/no-var-requires
			const store = require('../../main');

			if (store.default) {
				const {
					CreateEventReducer: {
						workingEvent
					},
					AuthReducer: {
						token
					}
				} = store.default.getState();

				if (workingEvent) {
					store.default.dispatch(isSavingEvent(true));
					const _workingEvent: BrandliveEvent = workingEvent;
					_workingEvent.status = 2;

					await SaveEvent(_workingEvent, token);

					if (REFETCHING_ACTION.includes(action.type)) {
						store.default.dispatch(loadWorkingEvent(_workingEvent.uuid, token!));
					}
					store.default.dispatch(isSavingEvent(false));
				}
			}
		}, 1000);
	}

	return newState;
}
